import React, { useContext } from 'react';
import { UserContext } from '../../context/UserContext';
import { HubSpotChat, HubSpotChatAnonymous } from './index';

const ChatLoader = () => {
    const {user} = useContext(UserContext);
    return user? <HubSpotChat /> : <HubSpotChatAnonymous />;
}

export default ChatLoader;
